const relativeTimeByLocales: any = {
  en: {
    future: 'in %s',
    past: '%s ago',
    h: '1 hour',
    d: '1 day',
    M: '1 month',
    m: '1 minute',
    y: '1 year',
    s: '1 second'
  },
  fr: {
    future: 'dans %s',
    past: 'il y a %s',
    h: '1 heure',
    d: '1 jour',
    M: '1 mois',
    m: '1 minute',
    y: '1 année',
    s: '1 seconde'
  }
};

export const langToLocale: any = {
  en: {
    text: 'en_US',
    format: 'dddd MMMM Do, YYYY'
  },
  fr: {
    text: 'fr_FR',
    format: 'dddd Do MMMM, YYYY'
  }
};

export default relativeTimeByLocales;
